// PBF endpoint templates for the web map's data server (KeyfiyatHavaTiles:
// vector tiles + label glyphs). maplibre-gl substitutes {z}/{x}/{y} with tile
// coordinates, and {fontstack}/{range} with the text layer's font stack
// (e.g. "Vazirmatn Regular") and the glyph range (e.g. 0-255) at request time.
const DEV_TILES_URL = 'http://localhost:8000/services/iran/tiles/{z}/{x}/{y}.pbf';
const PROD_TILES_URL = 'https://maps.ahooai.ir/services/iran/tiles/{z}/{x}/{y}.pbf';

const DEV_GLYPHS_URL = 'http://localhost:8000/fonts/{fontstack}/{range}.pbf';
const PROD_GLYPHS_URL = 'https://maps.ahooai.ir/fonts/{fontstack}/{range}.pbf';

export const TILES_URL = __DEV__ ? DEV_TILES_URL : PROD_TILES_URL;

export const GLYPHS_URL = __DEV__ ? DEV_GLYPHS_URL : PROD_GLYPHS_URL;
